import { render, staticRenderFns } from "./bizitravelonlineaktarim.vue?vue&type=template&id=540e138a&"
import script from "./bizitravelonlineaktarim.vue?vue&type=script&lang=js&"
export * from "./bizitravelonlineaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports